import React from "react";
import FixedBanner from "components/FixedBanner";
import { calculateMinZoneArea, getCoolingZoneErrorText } from "utils/singleZoneCooling";
import { formatArea } from "utils/displayMeasurements";
import classes from "./styles.module.scss";

const ZoneErrors = ({
    hasErrors = false,
    hasMinArea = true,
    numOfOccupants = 0,
    floorArea = 0,
    displayUnits = {
        areaDisplayUnits: "m2",
        perimeterDisplayUnits: "m",
    },
}) => {
    const { areaDisplayUnits } = displayUnits;

    const minArea = calculateMinZoneArea(numOfOccupants);
    const remainingArea = minArea - floorArea;

    return (
        <>
            {!hasMinArea && (
                <FixedBanner type="error" className={classes.errorBanner}>
                    <div>
                        {getCoolingZoneErrorText("minAreaRequired", formatArea(minArea, areaDisplayUnits))}
                        {" "}
                        {getCoolingZoneErrorText("minAreaRemaining", formatArea(remainingArea, areaDisplayUnits))}
                    </div>
                </FixedBanner>
            )}
            {hasErrors && (
                <FixedBanner type="error" className={classes.errorBanner}>
                    <div>{getCoolingZoneErrorText("requirementsNotMet")}</div>
                </FixedBanner>
            )}
        </>
    );
};

export default ZoneErrors;
